(() => {
  const root = document.querySelector('[data-ccv1-bite-box-landing]');
  if (!root) return;

  let syncing = false;
  let syncQueued = false;
  let frame = null;

  const cartUrl = () => {
    const shopRoot = window.Shopify?.routes?.root || '/';
    return `${shopRoot.replace(/\/?$/, '/')}cart.js`;
  };

  const formatMoney = (cents, currency = 'USD') => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const expectedComponents = (() => {
    const add = root.querySelector('[data-ccv1-bite-box-add][data-ccv1-bundle]');
    return String(add?.dataset.ccv1Bundle || '')
      .split(',')
      .map((entry) => {
        const [id, quantity = '1'] = entry.split(':');
        return { id: Number(id), quantity: Number(quantity) };
      })
      .filter((item) => Number.isInteger(item.id) && item.id > 0 && Number.isInteger(item.quantity) && item.quantity > 0);
  })();

  const hasBiteBox = (cart) => {
    if (!expectedComponents.length) return false;

    const stockupQuantities = new Map();
    (Array.isArray(cart?.items) ? cart.items : []).forEach((item) => {
      const family = String(item?.properties?._ccv1_offer_family || '').trim().toLowerCase();
      if (family !== 'stockup') return;
      const id = Number(item.variant_id || item.id);
      stockupQuantities.set(id, (stockupQuantities.get(id) || 0) + Number(item.quantity || 0));
    });

    return expectedComponents.every((component) => (
      (stockupQuantities.get(component.id) || 0) >= component.quantity
    ));
  };

  const setActionState = (inCart) => {
    root.dataset.ccv1BiteBoxInCart = String(inCart);

    root.querySelectorAll('[data-ccv1-bite-box-action]').forEach((action) => {
      const add = action.querySelector('[data-ccv1-bite-box-add]');
      const checkout = action.querySelector('[data-ccv1-bite-box-checkout]');
      if (add) add.hidden = inCart;
      if (checkout) checkout.hidden = !inCart;
    });

    const sticky = root.querySelector('[data-ccv1-mobile-buy]');
    if (!sticky) return;

    const stickyAdd = sticky.querySelector('[data-ccv1-bite-box-add]');
    const stickyCheckout = sticky.querySelector('[data-ccv1-bite-box-checkout]');
    sticky.dataset.ccv1HasCart = String(inCart);
    if (stickyAdd) stickyAdd.hidden = inCart;
    if (stickyCheckout) stickyCheckout.hidden = !inCart;
  };

  const updateStickySummary = (cart, inCart) => {
    const sticky = root.querySelector('[data-ccv1-mobile-buy]');
    if (!sticky) return;

    const title = sticky.querySelector('[data-ccv1-mobile-title]');
    const variant = sticky.querySelector('[data-ccv1-mobile-variant]');
    const checkoutMeta = sticky.querySelector('[data-ccv1-mobile-checkout-meta]');

    if (inCart) {
      const total = formatMoney(cart?.total_price, cart?.currency || 'USD');
      if (title) title.textContent = 'IN YOUR CART';
      if (variant) variant.textContent = `Bite Box · ${total}`;
      if (checkoutMeta) checkoutMeta.textContent = `Cart · ${total}`;
      return;
    }

    if (title) title.textContent = 'THE BITE BOX';
    if (variant) {
      variant.replaceChildren();
      const originalPrice = root.dataset.ccv1BiteBoxOriginalPrice;
      const offerPrice = root.dataset.ccv1BiteBoxOfferPrice;
      if (originalPrice) {
        const original = document.createElement('s');
        original.textContent = originalPrice;
        variant.append(original, document.createTextNode(' '));
      }
      variant.append(document.createTextNode(offerPrice || ''));
    }
    if (checkoutMeta) checkoutMeta.textContent = '';
  };

  const sync = async () => {
    if (syncing) {
      syncQueued = true;
      return;
    }

    syncing = true;
    try {
      const response = await fetch(cartUrl(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      const inCart = hasBiteBox(cart);
      setActionState(inCart);
      updateStickySummary(cart, inCart);
    } catch (_error) {
      // Leave the server-rendered add state intact if cart state cannot be read.
    } finally {
      syncing = false;
      if (syncQueued) {
        syncQueued = false;
        sync();
      }
    }
  };

  const scheduleSync = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(() => {
      frame = null;
      sync();
    });
  };

  window.addEventListener('ccv1:cart-state', (event) => {
    const cart = event?.detail?.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    const inCart = hasBiteBox(cart);
    setActionState(inCart);
    updateStickySummary(cart, inCart);
  });
  window.addEventListener('pageshow', scheduleSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
})();
